import React from 'react';
import { Link } from 'react-router';
import Base from 'client/components/base';
import Image from 'client/components/common/image';
import Strings from 'client/stores/strings';
import baseUrl from 'server/routes/base-url';
import moment from 'moment';
import _ from 'underscore';

export default class ButtonAcast extends Base {
  constructor(props) {
    super(props);

    moment.locale('en');
  }

  render() {
    let model = this.props.model;
    let url = `${baseUrl}${model.channel.url}/${model.url}`;

    let duration = '--:--';
    if (this.props.model.duration) {
      duration = this.formatDuration(this.props.model.duration);
    }

    let show = this.props.model.channel.name;
    if (show.length > 20) {
      show = show.substring(0, 20) + '…';
    }

    let title = this.props.model.name;
    if (title.length > 30) {
      title = title.substring(0, 30) + '…';
    }

    let date = moment(this.props.model.publishingDate);
    let formattedDate = date.format('ll');

    let imageStyle = {
      backgroundImage: `url(${this.props.model.image})`,
    };

    let rootClassName = this.css();
    let coverClassName = this.css({ base: 'cover' });
    let infoClassName = this.css({ base: 'info' });
    let positionClassName = this.css({ base: 'position' });
    let showClassName = this.css({ base: 'show' });
    let titleClassName = this.css({ base: 'title' });
    let timeClassName = this.css({ base: 'time' });
    let dateClassName = this.css({ base: 'date' });

    return (
      <Link to={url}>
        <div className={rootClassName}>
          <div className={coverClassName}>
            <Image className="channel-cover" model={this.props.model} />
            <img className="play-button" src={this.playOrLockIcon} />
          </div>
          <div className={infoClassName}>
            <div className={showClassName}>
              <div className={positionClassName}>{this.props.position}.</div>
              <div className={timeClassName}>{duration}</div>
              <div className="show-title">{this.props.model.channel.name}</div>
            </div>
            <div className={titleClassName}>
              <div className={timeClassName}>{duration}</div>
              <div className="episode-title" title={this.props.model.name}>
                {this.props.model.name}
              </div>
            </div>
            <div className={dateClassName}>{formattedDate}</div>
          </div>
        </div>
      </Link>
    );
  }

  get playOrLockIcon() {
    let now = new Date();
    let isLocked = _.some(this.props.model.permissions || [], function(
      permission
    ) {
      return (
        permission.type === 'purchase' &&
        new Date(permission.startDate) < now &&
        (!permission.endDate || new Date(permission.endDate) > now)
      );
    });

    if (isLocked) {
      return 'https://cdn.acast.com/images/icons/lockbutton.png';
    }

    return 'https://cdn.acast.com/images/icons/playbutton.png';
  }
}



// WEBPACK FOOTER //
// ./client/components/common/button-acast/button-acast.es6